import styled from '@emotion/styled';
import React from 'react';

/* Bordered card with a header bar (title, optional pill/caption, optional action) */
const SectionCard = ({ title, pill, caption, action, children }) => (
  <Card>
    <CardHeader>
      <div>
        <div className="title-row">
          <h3>{title}</h3>
          {pill && <span className="pill">{pill}</span>}
        </div>
        {caption && <p>{caption}</p>}
      </div>
      {action}
    </CardHeader>
    <CardBody>{children}</CardBody>
  </Card>
);

const Card = styled("div")`
  border: 1px solid rgba(101, 122, 144, 0.22);
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
  min-width: 0;
  button{ text-transform: none; }
`;
const CardHeader = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.75rem 1rem;
  background: rgba(101, 122, 144, 0.06);
  border-bottom: 1px solid rgba(101, 122, 144, 0.18);
  .title-row{ display: flex; align-items: center; gap: 0.6rem; flex-wrap: wrap; }
  h3{ margin: 0; font-family: "semi-bold"; font-size: 95%; }
  p{ margin: 0.2rem 0 0; font-size: 78%; color: rgba(101, 122, 144, 1); }
  .pill{
    font-size: 72%;
    padding: 2px 10px;
    border-radius: 999px;
    border: 1px solid rgba(101, 122, 144, 0.35);
    background: #fff;
    color: rgba(101, 122, 144, 1);
    white-space: nowrap;
  }
  button{ border-radius: 5px; flex-shrink: 0; }
`;
const CardBody = styled("div")`
  padding: 0.25rem 1rem 0.75rem;
`;

export default SectionCard;
